import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import CollectionCover from 'components/CollectionCover';
import { type OtherCollectionsProps } from './types';
import { OtherCollectionsWrapper, StyleCollectionsHeadline } from './styled';

const OtherCollections: FC<OtherCollectionsProps> = ({ collections, name, username }) => {
  const { t } = useTranslation();

  return (
    <OtherCollectionsWrapper data-test-id="other_collections_wrapper">
      <StyleCollectionsHeadline
        data-test-id="other_collections_headline"
        align="center"
        font="secondary"
        textColor="primary"
        size="header2"
        bold
        uppercase
        as="h2"
        data-name-attribute={`${name}`}
      >
        {t('collection.otherCollections', { creator: name?.toUpperCase() })}
      </StyleCollectionsHeadline>
      {collections.map((collection) => (
        <CollectionCover
          data-test-id="collections_cover"
          key={collection?.id}
          collection={{ ...collection, username }}
          collectionId={collection?.id}
        />
      ))}
    </OtherCollectionsWrapper>
  );
};

export default OtherCollections;
